import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useTabProps } from '../hooks/useTabProps.js';
import { TabContainer, ControlWidth, Text } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useTabManager } from '../hooks/useTabManager/useTabManager.js';

function Tab(props) {
  var children = props.children,
    id = props.id,
    disabled = props.disabled,
    className = props.className;
  var _useTabProps = useTabProps(id),
    tabProps = _useTabProps.tabProps;
  var _useTabManager = useTabManager(),
    activeTab = _useTabManager.activeTab,
    stretch = _useTabManager.stretch;
  return /*#__PURE__*/jsxs(TabContainer, _extends({}, tabProps, {
    $stretch: stretch,
    $isActive: id === activeTab,
    disabled: disabled,
    className: className,
    children: [/*#__PURE__*/jsx(ControlWidth, {
      "aria-hidden": "true",
      children: children
    }), /*#__PURE__*/jsx(Text, {
      children: children
    })]
  }));
}

export { Tab };
